import Grid from './Grid'
import GridItem from './GridItem'

Grid.Item = GridItem

export default Grid
